import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Container, Row, Table, Button, Form, Col } from 'react-bootstrap'
import { ToastContainer } from 'react-toastify'
import * as Icon from "react-bootstrap-icons";
import { useDispatch, useSelector } from 'react-redux';
import { getEmployeeData } from './HrSlice';
import { useNavigate } from 'react-router-dom';
import "react-toastify/dist/ReactToastify.css";
import FilterEmpDetailsModel from './Model/FilterEmpDetailsModel';
import DeleteEmpModel from './Model/DeleteEmpModel';
import Pagination from '../Common/Pagination';
import EditEmployeeDetailsModel from './Model/EditEmployeeDetails';
import AssignToTlModel from './Model/AssignToTlModel';
import AssignTlToDepartmentModel from './Model/AssignTlToDepartmentModel';
import AssignManagerToDepartmentModel from './Model/AssignManagerToDepartmentModal';
import AssignManagerToProjectModel from './Model/AssignManagerToProjectModel';
import RejectEmployeeModal from './Model/EmployeeRejectModal';
import ViewEmployeeFilter from '../Common/Filter/ViewEmployeeFilter';
import useGetEmployees from '../Common/ReuseApi/useGetEmployees';
import { ResourceTypeOptions } from '../utils/constant';
import useGetDepartments from '../Common/ReuseApi/useGetDepartments';
import useGetSubDepartments from '../Common/ReuseApi/useGetSubDepartments';

const Employees = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  // Employee Details
  const employeeData = useSelector(state => state?.employeeDetails?.employeeData);
  const loginUserData = useSelector((state) => state?.loginData?.userData);

  const [show, setShow] = useState(false);
  const [showFilter, setShowFilter] = useState(false)
  const [showassigntotl, setAssignToTl] = useState(false)
  const [showassigntltodept, setAssignTLToDept] = useState(false)
  const [showAssignManagerToDept, setShowAssignManagerToDept] = useState(false);
  const [showAssignManagerToProject, setShowAssignManagerToProject] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [rejectErr, setRejectErr] = useState(false);
  const [taskId, setTaskId] = useState("")
  const [rejected, setRejected] = useState([])
  const [approve, setApprove] = useState([])
  const [item, setItem] = useState();

  // filter state
  const [empId, setEmpId] = useState(null);
  const [departmentName, setDepartmentName] = useState(null);
  const [subDepartment, setSubDepartment] = useState(null);
  const [resourceType, setResourceType] = useState(null);
  const [approval, setApproval] = useState(null);

  // call custom hook
  const { employeeOptions } = useGetEmployees();
  const { allDepartmentOptionsById } = useGetDepartments();
  const { subDeptOptions } = useGetSubDepartments(departmentName?.value);

  // state for pagination
  const [docsPerPage, setDocsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // for edit task state
  const [showEdit, setShowEdit] = useState(false)

  // for delete model
  const handlerCloseModel = () => { setShow(false); }
  const handlerCloseFilterModel = () => setShowFilter(false)
  const handleCloseAssignToTlModel = () => setAssignToTl(false)
  const handleCloseAssignTLToDeptModel = () => setAssignTLToDept(false)


  const getManageEmpData = (page = currentPage) => {
    const endpoint = "/emp/getallemp1"
    const payload = {
      empId: empId?.value || "",
      name: "",
      label: "",
      resourceType: resourceType?.value || "",
      experience: "",
      isApproved: approval?.value ?? "",
      subDepartmentId: subDepartment?.value || "",
      department_id: departmentName?.value || "",
      documentsPerPage: docsPerPage,
      page: page
    }
    dispatch(
      getEmployeeData({ endpoint, payload: payload }))
  }
  useEffect(() => {
    getManageEmpData()
  }, [approve, rejected, currentPage, docsPerPage,]);

  // for reject flow
  const handleRejectSubmit = async () => {
    if (!rejectReason.trim()) {
      setRejectErr(true);
      return;
    }

    let payload = {
      empId: selectedEmp?.empId,
      isRejected: "true",
      rejectionReason: rejectReason,
    };

    try {
      const res = await axios.put(
        process.env.REACT_APP_BASE_URL + "/emp/updateEmployee",
        payload
      );

      setRejected(res.data.data);
      setShowRejectModal(false);
      setRejectReason('');
      setSelectedEmp(null);

    } catch (err) {
      console.log(err);
    }
  };

  const handleApprove = async (values) => {
    let payload = {
      empId: values.empId,
      // isApproved: "true",
    };
    await axios
      .post(process.env.REACT_APP_BASE_URL + "/emp/approveemployee", payload)
      .then((res) => {
        setApprove(res.data.data)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // function for pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);

  };
  const handleDocsPerPage = (docsPageProp) => {
    setCurrentPage(1);
    setDocsPerPage(docsPageProp);
  }


  // for edit model
  const handleShowEditModal = (id) => {
    setItem(id)
    setShowEdit(id)

  }
  const handleEditModalClose = () => {
    setShowEdit(false)
    setItem("");
    getManageEmpData()
  }

  const handleSearch = () => {
    setCurrentPage(1)
    getManageEmpData(1)
  }
  const handleClear = () => {
    setEmpId(null);
    setDepartmentName(null);
    setSubDepartment(null);
    setResourceType(null);
    setApproval(null);

    setCurrentPage(1);
    dispatch(getEmployeeData({
      endpoint: "/emp/getallemp1",
      payload: {
        empId: "",
        name: "",
        label: "",
        resourceType: "",
        experience: "",
        isApproved: "",
        subDepartmentId: "",
        department_id: "",
        documentsPerPage: docsPerPage,
        page: currentPage
      }
    }))
  }
  return (
    <div className="outletPadding" data-aos="fade-up">
      <Container>
        <ToastContainer />
        <ViewEmployeeFilter
          role={loginUserData?.resourceType}
          employeeOptions={employeeOptions}
          departmentOptions={allDepartmentOptionsById}
          subDeptOptions={subDeptOptions}
          resourceTypeOptions={ResourceTypeOptions}

          empId={empId}
          setEmpId={setEmpId}
          departmentName={departmentName}
          setDepartmentName={setDepartmentName}
          subDepartment={subDepartment}
          setSubDepartment={setSubDepartment}
          resourceType={resourceType}
          setResourceType={setResourceType}
          approval={approval}
          setApproval={setApproval}

          onSearch={handleSearch}
          onClear={handleClear}
        />
        <DeleteEmpModel show={show} close={handlerCloseModel} id={taskId} reCallData={getManageEmpData} />
        <EditEmployeeDetailsModel show={showEdit} close={handleEditModalClose} taskId={taskId} item={item} userData={loginUserData} />
        <FilterEmpDetailsModel show={showFilter} close={handlerCloseFilterModel} />
        <AssignToTlModel show={showassigntotl} close={handleCloseAssignToTlModel} />
        <AssignTlToDepartmentModel close={handleCloseAssignTLToDeptModel} show={showassigntltodept} />
        <AssignManagerToDepartmentModel close={() => setShowAssignManagerToDept(false)} show={showAssignManagerToDept} />
        <AssignManagerToProjectModel close={() => setShowAssignManagerToProject(false)} show={showAssignManagerToProject} />
        <RejectEmployeeModal show={showRejectModal}
          onClose={() => {
            setShowRejectModal(false);
            setRejectReason('');
            setRejectErr(false);
          }}
          rejectReason={rejectReason}
          setRejectReason={setRejectReason}
          rejectErr={rejectErr}
          setRejectErr={setRejectErr}
          onSubmit={handleRejectSubmit}
        />
        <Row className='m-3 d-flex flex-column flex-md-row justify-content-between align-items-center'>
          <Col sm={12} md={10} className="d-flex flex-wrap gap-2 justify-content-start justify-md-content-start align-items-center mb-3 mb-md-0">
            <Button
              size='sm'
              className="primaryBtn btn-16 px-3 gap-1"
              onClick={() => { setAssignToTl(true) }}
            >
              <Icon.PersonCheck className='' size={17} />Assign Employee To TL
            </Button>

            {/* <Button
              size='sm'
              className="primaryBtn gap-1"
              onClick={() => { setAssignTLToDept(true) }}
            >
              <Icon.PersonCheck className='' size={17} />Assign TL To Dept
            </Button> */}

            {/* <Button
              size='sm'
              className="primaryBtn gap-1"
              onClick={() => { setShowAssignManagerToDept(true) }}
            >
              <Icon.PersonCheck className='' size={17} />Assign Manager To Dept
            </Button> */}

            <Button
              size='sm'
              className="primaryBtn gap-1"
              onClick={() => { setShowAssignManagerToProject(true) }}
            >
              <Icon.PersonCheck className='' size={17} />Assign Manager To Project
            </Button>
          </Col>
        </Row>

        <div className='outer-wrapper mx-auto'>
          <div className='table-wrapper'>
            <table>
              <thead>
                <tr className='tbl-header'>
                  <th>Sr. No.</th>
                  <th>Employee ID</th>
                  <th className='assignwidth'>Name</th>
                  <th>Department</th>
                  <th>SubDepartment</th>
                  <th>Designation</th>
                  <th>Experience</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {
                  employeeData?.data !== null &&
                    employeeData?.data !== undefined &&
                    employeeData?.data?.length > 0
                    ? employeeData?.data?.map((row, index) => {
                      return (
                        <tr style={{ textAlign: "left" }}>
                          <td>{currentPage !== 1 ? (<>{index + 1 + docsPerPage * (currentPage - 1)}</>
                          ) : (<>{index + 1}</>)}</td>

                          <td>{row?.empId}</td>
                          <td>{`${row?.firstName} ${row?.lastName}`}</td>
                          {/* <td>{row?.department[0]?.label}</td> */}
                          <td>{row?.department[0]?.label ? row?.department[0]?.label : "-"}</td>
                          <td>{row?.subDepartmentName[0] ? row?.subDepartmentName[0] : "-"}</td>
                          <td>{row?.designation}</td>
                          <td>{row?.experience}</td>
                          <td>
                            <div className="approvalstatus ">
                              <div style={{ color: "#DFF2FB" }}>
                                {
                                  row?.isApproved === true ? (
                                    <button
                                      className="approval-btn "
                                      disabled
                                      style={{ backgroundColor: "green" }}>
                                      <div className="icon-approval" style={{ fontSize: '15px' }}>
                                        <span className="check-arrow">
                                          <Icon.Check
                                            style={{
                                              fontSize: "20px",
                                              color: "#59AC59",
                                              fontWeight: "bold",
                                            }}
                                          />
                                        </span>
                                        Approved
                                      </div>
                                    </button>
                                  ) : row.isRejected === true ? (
                                    ""
                                  ) : (
                                    <Button
                                      className="approval-btn"
                                      onClick={() => handleApprove(row)}
                                    >
                                      Approve
                                    </Button>
                                  )}
                              </div>

                              {row?.isApproved === true ? (
                                ""
                              ) : row?.isRejected === true ? (
                                <div style={{ color: "#FFDFE1" }}>
                                  <button
                                    disabled
                                    className="reject-btn"
                                    style={{ backgroundColor: "red" }}
                                  >
                                    <div className="icon-approval" style={{ fontSize: '15px' }}>
                                      <span className="check-arrow">
                                        <Icon.X
                                          style={{
                                            fontSize: "20px",
                                            color: "#F85253",
                                            fontWeight: "bold",
                                          }}
                                        />
                                      </span>
                                      Rejected
                                    </div>
                                  </button>
                                </div>
                              ) : (
                                <div
                                  data-toggle="modal"
                                  style={{ color: "#FFDFE1" }}
                                >
                                  <Button
                                    className="reject-btn"
                                    onClick={() => {
                                      setSelectedEmp(row);
                                      setShowRejectModal(true);
                                    }}
                                  // onClick={() => handleReject(row)}
                                  >
                                    Reject
                                  </Button>
                                </div>
                              )}
                            </div>
                          </td>

                          <td>
                            <span
                              data-toggle="tooltip"
                              title="view"
                              style={{
                                color: "#000000",
                                fontSize: "20px",
                              }}>
                              <Icon.Eye className='me-2'
                                onClick={() => {
                                  navigate('employee-details', {
                                    state: { data: row }
                                  })
                                }}
                              />
                            </span>
                            {
                              !row?.isRejected && (
                                <span
                                  data-toggle="tooltip"
                                  title="edit"
                                >
                                  <Icon.PencilSquare
                                    className='me-2'
                                    size={20}
                                    onClick={() => { handleShowEditModal(row); }}
                                  />
                                </span>
                              )
                            }
                            <span
                              data-toggle="tooltip"
                              title="delete"
                              style={{
                                color: "#000000",
                                fontSize: "20px",
                              }}>
                              <Icon.Trash className='me-2' onClick={() => { setTaskId(row.empId); setShow(true) }} />
                            </span>
                          </td>
                        </tr>
                      );
                    })
                    : <tr>
                      <td colSpan="13" className="text-center">No data found</td>
                    </tr>}
              </tbody>


            </table>
          </div>
        </div>
        <div className="pagination-wrapper p-0">
          <Pagination currentPage={currentPage} totalPages={employeeData?.noOfPages}
            onPageChange={handlePageChange} onDocsPerPage={handleDocsPerPage} docsPerPage={docsPerPage} />
        </div>
      </Container>
    </div>
  )
}

export default Employees
